import { memo, useCallback } from 'react';

import { useTrackClickedNotificationsIcon } from '@air/analytics';
import { Bell } from '@air/next-icons';

import { useGetNotificationSummary } from '~/components/AirNotifications/hooks/useGetNotificationSummary';
import { useResetUnviewedCount } from '~/components/AirNotifications/hooks/useResetUnviewedCount';
import { WorkspaceSidebarNavigationItem } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarNavigationItem';
import { useWorkspaceNotificationsStore } from '~/components/v2/store/features/workspace/useWorkspaceNotificationsStore';
import { AIR_NOTIFICATIONS_BUTTON, AIR_NOTIFICATIONS_BUTTON_BADGE } from '~/constants/testIDs';

export const WorkspaceSidebarNavigationItemNotifications = memo(() => {
  const { data: notificationSummary } = useGetNotificationSummary();
  const { resetUnviewedCount } = useResetUnviewedCount();
  const open = useWorkspaceNotificationsStore((store) => store.open);
  const toggleOpen = useWorkspaceNotificationsStore((store) => store.toggleOpen);
  const { trackClickedNotificationsIcon } = useTrackClickedNotificationsIcon();

  const onClick = useCallback(() => {
    if (!open) {
      resetUnviewedCount();
      trackClickedNotificationsIcon({ unviewedNotifications: notificationSummary?.unseen });
    }

    toggleOpen();
  }, [notificationSummary?.unseen, open, resetUnviewedCount, toggleOpen, trackClickedNotificationsIcon]);

  return (
    <WorkspaceSidebarNavigationItem data-selected={open} data-testid={AIR_NOTIFICATIONS_BUTTON} onClick={onClick}>
      <Bell className="size-4 shrink-0" />
      <span className="grow truncate">Notifications</span>
      {notificationSummary && notificationSummary.unseen > 0 && (
        <div
          className="flex h-4 min-w-[16px] shrink-0 items-center justify-center rounded-4 bg-red-8 px-1 text-center font-bold text-10 text-white tabular-nums"
          data-testid={AIR_NOTIFICATIONS_BUTTON_BADGE}
        >
          {notificationSummary.unseen}
        </div>
      )}
    </WorkspaceSidebarNavigationItem>
  );
});

WorkspaceSidebarNavigationItemNotifications.displayName = 'WorkspaceSidebarNavigationItemNotifications';
